/* ============================================================
   VOYAGE GOLF MARRAKECH — réservation (2 options : Profil + Chambre)
   câblée aux vraies variantes Shopify. + header sticky + reveal + smooth-scroll.
   Total = variant.compare_at_price · Acompte = variant.price (40 %). Pas de sold-out.
   ============================================================ */
(function () {
  'use strict';

  function euro(n, decimals) {
    return n.toLocaleString('fr-FR', {
      minimumFractionDigits: decimals ? 2 : 0,
      maximumFractionDigits: decimals ? 2 : 0
    }) + ' €';
  }

  function setupHeader() {
    var header = document.getElementById('gm-header');
    var hero = document.getElementById('top');
    if (!header) return;
    var update = function () {
      var th = hero ? hero.offsetHeight * 0.8 : window.innerHeight * 0.8;
      header.classList.toggle('is-stuck', window.scrollY > th);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function setupReveal() {
    var els = document.querySelectorAll('.dm-gm .reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function setupSmoothScroll() {
    var header = document.getElementById('gm-header');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function scrollTo(to, dur) {
      var start = window.pageYOffset, change = to - start, t0 = null;
      if (reduce) { window.scrollTo(0, to); return; }
      function step(ts) { if (t0 === null) t0 = ts; var p = Math.min((ts - t0) / dur, 1); window.scrollTo(0, start + change * ease(p)); if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    Array.prototype.forEach.call(document.querySelectorAll('.dm-gm a[href^="#"]'), function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href'); if (!id || id.length < 2) return;
        var t = document.querySelector(id); if (!t) return;
        e.preventDefault();
        var off = (header ? header.offsetHeight : 0) + 10;
        scrollTo(t.getBoundingClientRect().top + window.pageYOffset - off, 800);
      });
    });
  }

  function setupBooking() {
    var widget = document.getElementById('gm-widget');
    if (!widget) return;
    var variants = [];
    var dataEl = document.getElementById('gm-variant-data');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

    var profilCards = Array.prototype.slice.call(widget.querySelectorAll('.gm-opt[data-profil]'));
    var chambreCards = Array.prototype.slice.call(widget.querySelectorAll('.gm-opt[data-chambre]'));
    var totalEl = document.getElementById('gm-total');
    var depEl = document.getElementById('gm-deposit');
    var cta = document.getElementById('gm-book-cta');
    var form = document.getElementById('gm-product-form');
    var hidden = form ? form.querySelector('[data-variant-id]') : null;

    var state = {
      profil: profilCards.length ? profilCards[0].getAttribute('data-profil') : '',
      chambre: chambreCards.length ? chambreCards[0].getAttribute('data-chambre') : ''
    };

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].profil === state.profil && variants[i].chambre === state.chambre) return variants[i];
      }
      return null;
    }

    function render() {
      profilCards.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-profil') === state.profil); });
      chambreCards.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-chambre') === state.chambre); });
      var v = findVariant();
      if (!v) return;
      if (hidden) hidden.value = v.id;
      if (totalEl) totalEl.textContent = euro((v.compare || v.price) / 100, false);
      if (depEl) depEl.textContent = euro(v.price / 100, false);
      if (cta) {
        if (v.available === false) { cta.textContent = 'Indisponible'; cta.classList.add('is-disabled'); cta.setAttribute('aria-disabled', 'true'); }
        else { cta.textContent = 'Réserver ma place'; cta.classList.remove('is-disabled'); cta.removeAttribute('aria-disabled'); }
      }
    }

    profilCards.forEach(function (c) { c.addEventListener('click', function () { state.profil = c.getAttribute('data-profil'); render(); }); });
    chambreCards.forEach(function (c) { c.addEventListener('click', function () { state.chambre = c.getAttribute('data-chambre'); render(); }); });
    render();

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = findVariant();
        if (v && v.available === false) return;
        if (hidden && v) hidden.value = v.id;
        if (cta) { cta.classList.add('is-disabled'); cta.textContent = 'Ajout en cours…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add_failed'); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { form.submit(); });
      });
    }
  }

  function init() {
    try { localStorage.setItem('dm_return_url', window.location.pathname); } catch (e) {}
    setupHeader();
    setupReveal();
    setupSmoothScroll();
    setupBooking();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
